const Header = () => (
    <div className="header">
        <img src={`${process.env.PUBLIC_URL}/images/animareska_logo.png`} alt="Animareska Logo анимареска" />
    </div>
);

export default Header;
